var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center my-4"},[_vm._v("Are you sure to delete this permission?")]),_c('ActionButtons',{attrs:{"title":"Enter"},on:{"cancel":function($event){return _vm.$emit('closeDialog')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }